// extracted by mini-css-extract-plugin
export var copyableField = "_om-4";
export var customerBadge = "_om-0";
export var customerInfoTitle = "_om-2";
export var details = "_om-1";
export var dropdownContainer = "_om-5";
export var dropdownImage = "_om-6";
export var editAssigneeForm = "_om-a";
export var editButton = "_om-3";
export var email = "_om-7";
export var hidden = "_om-d";
export var input = "_om-8";
export var saveButton = "_om-b";
export var shopifyIcon = "_om-c";
export var suggestionBadge = "_om-e";
export var suggestionText = "_om-f";
export var username = "_om-9";